import _ from 'lodash';
import { ADMIN_CONTACT_SCHOOL } from '../constants/admin.contacts.constants';
import { PERMISSIONS } from '../constants/permissions.constants';

export const addStakeholderBody = (data) => {
  return {
    ..._.pick(data, ['email', 'role']),
    id: data?.contactId,
    firstname: data?.firstName,
    lastname: data?.lastName,
    organisation: data?.treePath,
    organisationRole: data?.roleKey,
    organisationName:
      data?.type === ADMIN_CONTACT_SCHOOL
        ? [PERMISSIONS.SCHOOL_ADMIN, PERMISSIONS.SCHOOL_MEDEWERKER].includes(data?.roleKey)
          ? data?.school
          : data?.schoolNet
        : data?.organization
  };
};

export const updateStakeholderBody = (data) => {
  return {
    ..._.pick(data, ['role'])
  };
};

export const addStakeholderUniqueId = (stakeholder) =>
  `${stakeholder?.id}-${stakeholder?.treePath}-${stakeholder?.role}`;
